import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const ArrowAngledIcon = React.memo(function ArrowAngledIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 11.5V3.49999C7 2.67157 7.67157 1.99999 8.5 1.99999H11.293L10.6465 1.35351C10.4512 1.15825 10.4512 0.841739 10.6465 0.646477C10.8417 0.451215 11.1583 0.451215 11.3535 0.646477L13.207 2.49999L11.3535 4.35351C11.1583 4.54877 10.8417 4.54877 10.6465 4.35351C10.4512 4.15825 10.4512 3.84174 10.6465 3.64648L11.293 2.99999H8.5C8.22386 2.99999 8 3.22385 8 3.49999V11.5C8 12.3284 7.32843 13 6.5 13H2.5C2.22386 13 2 12.7761 2 12.5C2 12.2238 2.22386 12 2.5 12H6.5C6.77614 12 7 11.7761 7 11.5Z"
        fill={color}
      />
    </svg>
  );
});
